import { FC } from "react";
import { Link } from "react-router-dom";
import { Col, Progress, Typography, Tooltip } from "antd";
import { ProgressRow, StyledButton, TextRow, Wrapper } from "./styled";
import { CheckCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
// import { userRolesStore } from "stores";

interface IProgressCardProps {
  progressPercentage: number;
  redirectUrl?: string;
  text: string;
  title?: string;
}

export const ProgressCard: FC<IProgressCardProps> = ({
  progressPercentage,
  redirectUrl,
  text,
  title = "Актуальность РД",
}) => {
  const isUncompleted = progressPercentage < 100;

  return (
    <Wrapper className="progress-card" data-testid="progress-card">
      <Typography.Title className="title" level={5}>{title}</Typography.Title>

      <TextRow gutter={8} align="middle">
        <Col>
          <Tooltip
            overlay={
              // userRolesStore.isNotJustCustomer()
              // ?
              "Вы можете видеть, сколько подрядных организаций ещё не приняли обновлённую рабочую документацию в работу"
              // : "Показывает, есть ли у вас обновлённая документация, которую вы не приняли"
            }
          >
            {isUncompleted ? <InfoCircleOutlined />: <CheckCircleOutlined />}
          </Tooltip>
        </Col>

        <Col>
          <Typography className="typography">{text}</Typography>
        </Col>
      </TextRow>

      <ProgressRow justify="space-between" align="middle" wrap={false}>
        <Col className="col-first-child ">
          <Progress percent={progressPercentage} />
        </Col>

        {redirectUrl && isUncompleted && (
          <Col>
            <Link to={redirectUrl} data-testid="progress-card-open">
              <StyledButton type="link">Открыть</StyledButton>
            </Link>
          </Col>
        )}
      </ProgressRow>
    </Wrapper>
  );
};
